<template>
  <div class="Setdepartment">
    <!-- <div class="Setdepartment_top">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item style="" label="量表名aa称">
          <el-input v-model="formInline.user" placeholder="量表名称："></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formInline.region" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="证件号">
          <el-input v-model="formInline.region" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="测试时间">
          <el-date-picker v-model="value1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>

        </el-form-item>
        <el-form-item class="cvbb" style="width:260px">
          <el-button type="primary">筛选</el-button>
          <el-button type="primary" @click="resetForm('form')" plain>重置</el-button>
        </el-form-item>

      </el-form>
    </div> -->

    <!-- <div class="Thelist">
      <div style="width:800px">
        <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
          删除所选数据
        </el-button>
        <el-button type="primary" @click="dialogVisible = true" plain>主要按钮</el-button>
      </div> -->

    <el-table :data="tableData" style="width: 100%;">
      <el-table-column label="日期" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px;">{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>姓名: {{ scope.row.name }}</p>
            <p>住址: {{ scope.row.address }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            添加初始访谈
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
            修改
          </el-button>
          <el-button size="mini" type="success" @click="handleDelete(scope.$index, scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <el-drawer  :visible.sync="drawer" :with-header="false">
        <el-form :model="from" :rules="rules" ref="from"  label-width="100px" class="demo-ruleForm" >


          <el-form-item style="width: 100%;" >
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>知情说明（是否保密和知情同意）</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="276px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1" >
            <el-radio-group v-model="from.AnswerName1">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="234px" label="知情同意讨论（书面和口头）" prop="AnswerName2">
            <el-radio-group v-model="from.AnswerName2">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName3"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>危机评估</p>
            </div>
          </el-form-item>

          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">自我伤害危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="208px" label="风险评估及心理干预提示" prop="AnswerName4" >
            <el-radio-group v-model="from.AnswerName4" prop="name">
              <el-radio label="0 无自我伤害风险(常规性的咨询)"></el-radio><br>
              <el-radio label="1 有风险但能自控(关注风险的咨询)"></el-radio><br>
              <el-radio label="2 有风险不能完全自控(制定安全计划、报告相关机构)"></el-radio><br>
              <el-radio label="3 高风险完全不能自控(紧急综合干预、报告相关机构)"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="244px" label="保护因素评估──咨询/求助动机" prop="AnswerName5">
            <el-radio-group v-model="from.AnswerName5">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──家庭支持" prop="AnswerName6">
            <el-radio-group v-model="from.AnswerName6">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──社会支持" prop="AnswerName7">
            <el-radio-group v-model="from.AnswerName7">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="240px" label="保护因素评估──问题解决能力" prop="AnswerName8">
            <el-radio-group v-model="from.AnswerName8">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

           <el-form-item disabled="true" label-width="240px" label="保护因素评估──活下去的希望" prop="AnswerName9">
            <el-radio-group v-model="from.AnswerName9">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="252px" label="保护因素评估──积极的宗教s信仰" prop="AnswerName10">
            <el-radio-group v-model="from.AnswerName10">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="342px" label="保护因素评估──不想让有些/某个重要人物失望 " prop="AnswerName11">
            <el-radio-group v-model="from.AnswerName11">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="保护因素评估──其他相关因素" label-width="246px" prop="AnswerName12">
            <el-input type="textarea" maxlength="500" show-word-limit v-model="from.AnswerName12"></el-input>
          </el-form-item>

          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">伤害他人危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="208px" label="风险评估及心理干预提示" prop="AnswerName13" >
            <el-radio-group v-model="from.AnswerName13">
              <el-radio label="0 无自我伤害风险(常规性的咨询)"></el-radio><br>
              <el-radio label="1 有风险但能自控(关注风险的咨询)"></el-radio><br>
              <el-radio label="2 有风险不能完全自控(制定安全计划、报告相关机构)"></el-radio><br>
              <el-radio label="3 高风险完全不能自控(紧急综合干预、报告相关机构)"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item disabled="true" label-width="244px" label="保护因素评估──咨询/求助动机" prop="AnswerName14">
            <el-radio-group v-model="from.AnswerName14">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──社会支持" prop="AnswerName15">
            <el-radio-group v-model="from.AnswerName15">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="240px" label="保护因素评估──问题解决能力" prop="AnswerName16">
            <el-radio-group v-model="from.AnswerName16">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

           <el-form-item disabled="true" label-width="200px" label="保护因素评估──自知力" prop="AnswerName17">
            <el-radio-group v-model="from.AnswerName17">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="200px" label="保护因素评估──自制力" prop="AnswerName18">
            <el-radio-group v-model="from.AnswerName18">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="256px" label="保护因素评估──积极的宗教信仰" prop="AnswerName19">
            <el-radio-group v-model="from.AnswerName19">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="保护因素评估──其他相关因素" label-width="244px" prop="AnswerName20">
            <el-input type="textarea" maxlength="500" show-word-limit v-model="from.AnswerName20"></el-input>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">自我照料危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="146px" label="自我照料危机" prop="UserID" >
            <el-radio-group v-model="from.AnswerName21">
              <el-radio label="0 无自我照料问题（正常咨询）"></el-radio><br>
              <el-radio label="1 自我照料略有不足（关注风险的咨询）"></el-radio><br>
              <el-radio label="2 自我照料受损明显（制定安全计划、报告相关机构）"></el-radio><br>
              <el-radio label="3 自我照料能力丧失（紧急综合干预、报告相关机构）"></el-radio>
            </el-radio-group>
          </el-form-item>



          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>一般精神状态评估</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="174px" label="焦虑表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName22">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="250px" label="注意力缺陷/多动表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName23">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="234px" label="抑郁/低落心境表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName24">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="212px" label="饮食不规律表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName25">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="232px" label="躁狂/轻度躁狂表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName26">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="精神病性表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName27">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="自伤倾向表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName28">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="睡眠问题表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName29">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="212px" label="物质滥用史表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName30">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName31"></el-input>
          </el-form-item>
       
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>来访者问题主诉</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="80px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="年龄" label-width="68px">
            <span>20</span>
          </el-form-item>

          <el-form-item label="性别" label-width="68px">
            <span>男</span>
          </el-form-item>

          <el-form-item label="来访时间" label-width="96px">
            <span>2020-02-05</span>
          </el-form-item>

          <el-form-item label="原因" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName36"></el-input>
          </el-form-item>

          <el-form-item label="诉求" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName37"></el-input>
          </el-form-item>
          
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>相关健康史（重大疾病史）</p>
            </div>
          </el-form-item>

          <el-form-item label="咨询师直接输入" label-width="140px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName38"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>个人成长史</p>
            </div>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">创伤史</h2>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="重大丧失" prop="UserID">
            <el-radio-group v-model="from.AnswerName39">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="暴力侵害" prop="UserID">
            <el-radio-group v-model="from.AnswerName40">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="92px" label="性侵害" prop="UserID">
            <el-radio-group v-model="from.AnswerName41">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>
          
         <el-form-item disabled="true" label-width="92px" label="被忽视" prop="UserID">
            <el-radio-group v-model="from.AnswerName42">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName43"></el-input>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">家族史</h2>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="精神病史" prop="UserID">
            <el-radio-group v-model="from.AnswerName44">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="80px" label="关系" prop="type">
            <el-checkbox-group v-model="from.AnswerName44_1" >
              <el-checkbox label="父亲" name="type1"></el-checkbox>
              <el-checkbox label="母亲" name="type2"></el-checkbox>
              <el-checkbox label="祖父" name="type3"></el-checkbox>
              <el-checkbox label="祖母" name="type4"></el-checkbox>
              <el-checkbox label="外祖父" name="type5"></el-checkbox>
              <el-checkbox label="外祖母" name="type6"></el-checkbox>
              <el-checkbox label="其他亲戚" name="type7"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="自杀未遂" prop="UserID">
            <el-radio-group v-model="from.AnswerName45">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="自杀死亡" prop="UserID">
            <el-radio-group v-model="from.AnswerName46">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>
          
         <el-form-item disabled="true" label-width="134px" label="暴力攻击倾向" prop="UserID">
            <el-radio-group v-model="from.AnswerName47">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="酒精滥用" prop="UserID">
            <el-radio-group v-model="from.AnswerName48">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="物质滥用" prop="UserID">
            <el-radio-group v-model="from.AnswerName49">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName50"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>当前状况及社会功能评估</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="社会功能" prop="UserID">
            <el-radio-group v-model="from.AnswerName51">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName51_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="工作状况" prop="UserID">
            <el-radio-group v-model="from.AnswerName52">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName52_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="家庭支持" prop="UserID">
            <el-radio-group v-model="from.AnswerName53">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName53_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="社会支持" prop="UserID">
            <el-radio-group v-model="from.AnswerName54">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName54_1"></el-input>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName55"></el-input>
          </el-form-item>
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>来自咨询师的评估印象</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="80px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="来访原因" label-width="94px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName57"></el-input>
          </el-form-item>

          <el-form-item label="状态" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName58"></el-input>
          </el-form-item>

          <el-form-item label="存在的问题" label-width="110px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName59"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>咨询计划</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="84px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="咨询目标" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName61"></el-input>
          </el-form-item>

          <el-form-item label="治疗方法" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName62"></el-input>
          </el-form-item>

          <el-form-item label="咨询次数" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName63"></el-input>
          </el-form-item>

          <el-form-item label="咨询频率" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName64"></el-input>
          </el-form-item>

        </el-form>

        <el-button style="margin-bottom: 60px;margin-top:20px;margin-left:40%" @click="submitForm('from')" type="primary">保存</el-button>

      </el-drawer> -->

    <!-- 
      <el-drawer  :visible.sync="drawer" :with-header="false">
        <el-form :model="from" :rules="rules" ref="from"  label-width="100px" class="demo-ruleForm" >


          <el-form-item style="width: 100%;" >
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>知情说明（是否保密和知情同意）</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="276px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1" >
            <el-radio-group v-model="from.AnswerName1">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="234px" label="知情同意讨论（书面和口头）" prop="AnswerName2">
            <el-radio-group v-model="from.AnswerName2">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName3"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>危机评估</p>
            </div>
          </el-form-item>

          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">自我伤害危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="208px" label="风险评估及心理干预提示" prop="AnswerName4" >
            <el-radio-group v-model="from.AnswerName4" prop="name">
              <el-radio label="0 无自我伤害风险(常规性的咨询)"></el-radio><br>
              <el-radio label="1 有风险但能自控(关注风险的咨询)"></el-radio><br>
              <el-radio label="2 有风险不能完全自控(制定安全计划、报告相关机构)"></el-radio><br>
              <el-radio label="3 高风险完全不能自控(紧急综合干预、报告相关机构)"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="244px" label="保护因素评估──咨询/求助动机" prop="AnswerName5">
            <el-radio-group v-model="from.AnswerName5">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──家庭支持" prop="AnswerName6">
            <el-radio-group v-model="from.AnswerName6">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──社会支持" prop="AnswerName7">
            <el-radio-group v-model="from.AnswerName7">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="240px" label="保护因素评估──问题解决能力" prop="AnswerName8">
            <el-radio-group v-model="from.AnswerName8">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

           <el-form-item disabled="true" label-width="240px" label="保护因素评估──活下去的希望" prop="AnswerName9">
            <el-radio-group v-model="from.AnswerName9">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="252px" label="保护因素评估──积极的宗教s信仰" prop="AnswerName10">
            <el-radio-group v-model="from.AnswerName10">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="342px" label="保护因素评估──不想让有些/某个重要人物失望 " prop="AnswerName11">
            <el-radio-group v-model="from.AnswerName11">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="保护因素评估──其他相关因素" label-width="246px" prop="AnswerName12">
            <el-input type="textarea" maxlength="500" show-word-limit v-model="from.AnswerName12"></el-input>
          </el-form-item>

          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">伤害他人危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="208px" label="风险评估及心理干预提示" prop="AnswerName13" >
            <el-radio-group v-model="from.AnswerName13">
              <el-radio label="0 无自我伤害风险(常规性的咨询)"></el-radio><br>
              <el-radio label="1 有风险但能自控(关注风险的咨询)"></el-radio><br>
              <el-radio label="2 有风险不能完全自控(制定安全计划、报告相关机构)"></el-radio><br>
              <el-radio label="3 高风险完全不能自控(紧急综合干预、报告相关机构)"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item disabled="true" label-width="244px" label="保护因素评估──咨询/求助动机" prop="AnswerName14">
            <el-radio-group v-model="from.AnswerName14">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="211px" label="保护因素评估──社会支持" prop="AnswerName15">
            <el-radio-group v-model="from.AnswerName15">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="240px" label="保护因素评估──问题解决能力" prop="AnswerName16">
            <el-radio-group v-model="from.AnswerName16">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

           <el-form-item disabled="true" label-width="200px" label="保护因素评估──自知力" prop="AnswerName17">
            <el-radio-group v-model="from.AnswerName17">
              <el-radio label="强"></el-radio>
              <el-radio label="弱"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="200px" label="保护因素评估──自制力" prop="AnswerName18">
            <el-radio-group v-model="from.AnswerName18">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="256px" label="保护因素评估──积极的宗教信仰" prop="AnswerName19">
            <el-radio-group v-model="from.AnswerName19">
              <el-radio label="无"></el-radio>
              <el-radio label="有"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="保护因素评估──其他相关因素" label-width="244px" prop="AnswerName20">
            <el-input type="textarea" maxlength="500" show-word-limit v-model="from.AnswerName20"></el-input>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">自我照料危机</h2>
          </el-form-item>

          <el-form-item disabled="true" label-width="146px" label="自我照料危机" prop="UserID" >
            <el-radio-group v-model="from.AnswerName21">
              <el-radio label="0 无自我照料问题（正常咨询）"></el-radio><br>
              <el-radio label="1 自我照料略有不足（关注风险的咨询）"></el-radio><br>
              <el-radio label="2 自我照料受损明显（制定安全计划、报告相关机构）"></el-radio><br>
              <el-radio label="3 自我照料能力丧失（紧急综合干预、报告相关机构）"></el-radio>
            </el-radio-group>
          </el-form-item>



          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>一般精神状态评估</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="174px" label="焦虑表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName22">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="250px" label="注意力缺陷/多动表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName23">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="234px" label="抑郁/低落心境表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName24">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="212px" label="饮食不规律表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName25">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="232px" label="躁狂/轻度躁狂表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName26">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="精神病性表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName27">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="自伤倾向表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName28">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="198px" label="睡眠问题表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName29">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="212px" label="物质滥用史表现与/或症状" prop="UserID">
            <el-radio-group v-model="from.AnswerName30">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName31"></el-input>
          </el-form-item>
       
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>来访者问题主诉</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="80px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="年龄" label-width="68px">
            <span>20</span>
          </el-form-item>

          <el-form-item label="性别" label-width="68px">
            <span>男</span>
          </el-form-item>

          <el-form-item label="来访时间" label-width="96px">
            <span>2020-02-05</span>
          </el-form-item>

          <el-form-item label="原因" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName36"></el-input>
          </el-form-item>

          <el-form-item label="诉求" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName37"></el-input>
          </el-form-item>
          
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>相关健康史（重大疾病史）</p>
            </div>
          </el-form-item>

          <el-form-item label="咨询师直接输入" label-width="140px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName38"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>个人成长史</p>
            </div>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">创伤史</h2>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="重大丧失" prop="UserID">
            <el-radio-group v-model="from.AnswerName39">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="暴力侵害" prop="UserID">
            <el-radio-group v-model="from.AnswerName40">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="92px" label="性侵害" prop="UserID">
            <el-radio-group v-model="from.AnswerName41">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>
          
         <el-form-item disabled="true" label-width="92px" label="被忽视" prop="UserID">
            <el-radio-group v-model="from.AnswerName42">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName43"></el-input>
          </el-form-item>
          <el-form-item  label-width="40px" >
            <h2 style="font-size: 14px;">家族史</h2>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="精神病史" prop="UserID">
            <el-radio-group v-model="from.AnswerName44">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="80px" label="关系" prop="type">
            <el-checkbox-group v-model="from.AnswerName44_1" >
              <el-checkbox label="父亲" name="type1"></el-checkbox>
              <el-checkbox label="母亲" name="type2"></el-checkbox>
              <el-checkbox label="祖父" name="type3"></el-checkbox>
              <el-checkbox label="祖母" name="type4"></el-checkbox>
              <el-checkbox label="外祖父" name="type5"></el-checkbox>
              <el-checkbox label="外祖母" name="type6"></el-checkbox>
              <el-checkbox label="其他亲戚" name="type7"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="自杀未遂" prop="UserID">
            <el-radio-group v-model="from.AnswerName45">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="自杀死亡" prop="UserID">
            <el-radio-group v-model="from.AnswerName46">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>
          
         <el-form-item disabled="true" label-width="134px" label="暴力攻击倾向" prop="UserID">
            <el-radio-group v-model="from.AnswerName47">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="酒精滥用" prop="UserID">
            <el-radio-group v-model="from.AnswerName48">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

         <el-form-item disabled="true" label-width="106px" label="物质滥用" prop="UserID">
            <el-radio-group v-model="from.AnswerName49">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
              <el-radio label="尚未评估"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName50"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>当前状况及社会功能评估</p>
            </div>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="社会功能" prop="UserID">
            <el-radio-group v-model="from.AnswerName51">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName51_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="工作状况" prop="UserID">
            <el-radio-group v-model="from.AnswerName52">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName52_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="家庭支持" prop="UserID">
            <el-radio-group v-model="from.AnswerName53">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName53_1"></el-input>
          </el-form-item>

          <el-form-item disabled="true" label-width="106px" label="社会支持" prop="UserID">
            <el-radio-group v-model="from.AnswerName54">
              <el-radio label="极好"></el-radio>
              <el-radio label="好"></el-radio>
              <el-radio label="不好"></el-radio>
              <el-radio label="极差"></el-radio>
            </el-radio-group>
            <el-input style="margin-left:0px;"  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName54_1"></el-input>
          </el-form-item>

          <el-form-item label="其他" label-width="80px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName55"></el-input>
          </el-form-item>
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>来自咨询师的评估印象</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="80px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="来访原因" label-width="94px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName57"></el-input>
          </el-form-item>

          <el-form-item label="状态" label-width="68px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName58"></el-input>
          </el-form-item>

          <el-form-item label="存在的问题" label-width="110px">
            <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName59"></el-input>
          </el-form-item>

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>咨询计划</p>
            </div>
          </el-form-item>

          <el-form-item label="来访者" label-width="84px">
            <span>小金金</span>
          </el-form-item>

          <el-form-item label="咨询目标" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName61"></el-input>
          </el-form-item>

          <el-form-item label="治疗方法" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName62"></el-input>
          </el-form-item>

          <el-form-item label="咨询次数" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName63"></el-input>
          </el-form-item>

          <el-form-item label="咨询频率" label-width="100px">
             <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName64"></el-input>
          </el-form-item>

        </el-form>

        <el-button style="margin-bottom: 60px;margin-top:20px;margin-left:40%" @click="submitForm('from')" type="primary">保存</el-button>

      </el-drawer> -->

    <el-drawer :visible.sync="drawer" :with-header="false">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item style="width: 100%;">
          <div class="tit" style="margin-left: -80px;">
            <span></span>
            <p>基本信息</p>
          </div>
        </el-form-item>

        <el-form-item label="来访者" label-width="80px">
          <span>小金金</span>
        </el-form-item>
        <el-form-item label="咨询编号" label-width="96px">
          <span>8FE51D68-AB1A-4004-A996-B65E559ECD7A</span>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="工作方式">
          <el-radio-group v-model="from.AnswerName3">
            <el-radio label="普通来访"></el-radio>
            <el-radio label="紧急干预"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="工作场所">
          <el-radio-group v-model="from.AnswerName4">
            <el-radio label="咨询室"></el-radio>
            <el-radio label="家"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="咨询日期" prop="AnswerName5">
          <el-date-picker v-model="from.AnswerName5" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="咨询时间">
          <el-time-picker is-range v-model="from.AnswerName6" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
          </el-time-picker>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="咨询主题">
          <el-checkbox-group v-model="from.AnswerName8" :max="3">
            <el-checkbox label="1 . 社交关系" name="type"></el-checkbox>
            <el-checkbox label="2 . 家庭关系" name="type"></el-checkbox>
            <el-checkbox label="3 . 学业问题" name="type"></el-checkbox>
            <el-checkbox label="4 . 感情与性" name="type"></el-checkbox>
            <el-checkbox label="5 . 焦虑恐惧" name="type"></el-checkbox>
            <el-checkbox label="6 . 自我评价" name="type"></el-checkbox>
            <el-checkbox label="7 . 压力应对" name="type"></el-checkbox>
            <el-checkbox label="8 . 生涯发展" name="type"></el-checkbox>
            <el-checkbox label="9 . 生命意义" name="type"></el-checkbox>
            <el-checkbox label="10 . 睡眠问题" name="type"></el-checkbox>
            <el-checkbox label="11 . 饮食问题" name="type"></el-checkbox>
            <el-checkbox label="12 . 抑郁悲伤" name="type"></el-checkbox>
            <el-checkbox label="13 . 强迫现象" name="type"></el-checkbox>
            <el-checkbox label="14 . 成瘾问题" name="type"></el-checkbox>
            <el-checkbox label="15 . 冲动易怒" name="type"></el-checkbox>
            <el-checkbox label="16 . 个性特征" name="type"></el-checkbox>
            <el-checkbox label="17 . 其他问题" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item style="width: 100%;">
          <div class="tit" style="margin-left: -80px;">
            <span></span>
            <p>本次咨询目标与过程概要</p>
          </div>
        </el-form-item>

        <el-form-item label="问题" label-width="70px">
          <el-input maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName9"></el-input>
        </el-form-item>

        <el-form-item label="咨询目标" label-width="98px">
          <el-input  maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName10">
          </el-input>
        </el-form-item>

        <el-form-item disabled="true" label-width="96px" label="采用方法">
          <el-checkbox-group v-model="from.AnswerName11" :max="3">
            <el-checkbox label="心理教育" name="type"></el-checkbox>
            <el-checkbox label="情绪疏导" name="type"></el-checkbox>
            <el-checkbox label="认知调整" name="type"></el-checkbox>
            <el-checkbox label="行为改变" name="type"></el-checkbox>
            <el-checkbox label="家庭会谈" name="type"></el-checkbox>
            <el-checkbox label="学业咨询" name="type"></el-checkbox>
            <el-checkbox label="现实支持" name="type"></el-checkbox>
            <el-checkbox label="安全计划" name="type"></el-checkbox>
            <el-checkbox label="放松练习" name="type"></el-checkbox>
            <el-checkbox label="医疗转介" name="type"></el-checkbox>
            <el-checkbox label="生活方式管理" name="type"></el-checkbox>
            <el-checkbox label="其他" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="达成目标" label-width="98px">
          <el-input maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName12">
          </el-input>
        </el-form-item>

        <el-form-item disabled="true" label-width="154px" label="是否布置家庭作业">
          <el-radio-group v-model="from.AnswerName13">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
          <br />
          <el-input maxlength="500" show-word-limit type="textarea" v-model="from.AnswerName13_1">
          </el-input>
        </el-form-item>

        <el-form-item style="width: 100%;">
          <div class="tit" style="margin-left: -80px;">
            <span></span>
            <p>咨询中的危机评估</p>
          </div>
        </el-form-item>

        <el-form-item disabled="true" label-width="126px" label="自我伤害风险">
          <el-radio-group v-model="from.AnswerName14">
            <el-radio label="无"></el-radio>
            <el-radio label="轻微"></el-radio>
            <el-radio label="明显"></el-radio>
            <el-radio label="严重"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="126px" label="伤害他人风险" prop="UserID">
          <el-radio-group v-model="from.AnswerName15">
            <el-radio label="无"></el-radio>
            <el-radio label="轻微"></el-radio>
            <el-radio label="明显"></el-radio>
            <el-radio label="严重"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="126px" label="无法自我照顾" prop="UserID">
          <el-radio-group v-model="from.AnswerName16">
            <el-radio label="无"></el-radio>
            <el-radio label="轻微"></el-radio>
            <el-radio label="明显"></el-radio>
            <el-radio label="严重"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="width: 100%;">
          <div class="tit" style="margin-left: -80px;">
            <span></span>
            <p>改善状况</p>
          </div>
        </el-form-item>

        <el-form-item disabled="true" label-width="74px" label="情绪" prop="UserID">
          <el-radio-group v-model="from.AnswerName17">
            <el-radio label="明显改善"></el-radio>
            <el-radio label="有所改善"></el-radio>
            <el-radio label="轻微改善"></el-radio>
            <el-radio label="无明显改善"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="74px" label="认知" prop="UserID">
          <el-radio-group v-model="from.AnswerName18">
            <el-radio label="明显改善"></el-radio>
            <el-radio label="有所改善"></el-radio>
            <el-radio label="轻微改善"></el-radio>
            <el-radio label="无明显改善"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item disabled="true" label-width="74px" label="行为" prop="UserID">
          <el-radio-group v-model="from.AnswerName19">
            <el-radio label="明显改善"></el-radio>
            <el-radio label="有所改善"></el-radio>
            <el-radio label="轻微改善"></el-radio>
            <el-radio label="无明显改善"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="width: 100%;">
          <div class="tit" style="margin-left: -80px;">
            <span></span>
            <p>记录</p>
          </div>
        </el-form-item>

        <el-form-item label="咨询过程记录" label-width="130px">
          <el-input maxlength="1000" show-word-limit type="textarea" v-model="from.AnswerName20"></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="submitForm('from')" style="margin-bottom: 60px; margin-top: 20px; margin-left: 40%;" type="primary">
        保存
      </el-button>
    </el-drawer>
  </div>
  <!-- </div> -->
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      orderArray: [],
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          aaaa: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          aaaa: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          aaaa: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎', 
          address: '上海市普陀区金沙江路 1516 弄',
          aaaa: '上海市普陀区金沙江路 1518 弄',
        },
      ],
      // from:{
      //   AnswerName1:'',
      //   AnswerName2:'',
      //   AnswerName3:'',
      //   AnswerName4:'',
      //   AnswerName5:'',
      //   AnswerName6:'',
      //   AnswerName7:'',
      //   AnswerName8:'',
      //   AnswerName9:'',
      //   AnswerName10:'',
      //   AnswerName11:'',
      //   AnswerName12:'',
      //   AnswerName13:'',
      //   AnswerName14:'',
      //   AnswerName15:'',
      //   AnswerName16:'',
      //   AnswerName17:'',
      //   AnswerName18:'',
      //   AnswerName19:'',
      //   AnswerName20:'',
      //   AnswerName21:'',
      //   AnswerName22:'',
      //   AnswerName23:'',
      //   AnswerName24:'',
      //   AnswerName25:'',
      //   AnswerName26:'',
      //   AnswerName27:'',
      //   AnswerName28:'',
      //   AnswerName29:'',
      //   AnswerName30:'',
      //   AnswerName31:'',
      //   AnswerName32:'laifangzhe',
      //   AnswerName33:'19',
      //   AnswerName34:'男',
      //   AnswerName35:'2022年1月1号',
      //   AnswerName35:'',
      //   AnswerName37:'',
      //   AnswerName38:'',
      //   AnswerName39:'',
      //   AnswerName40:'',
      //   AnswerName41:'',
      //   AnswerName42:'',
      //   AnswerName43:'',
      //   AnswerName44:'',
      //   AnswerName44_1:[],
      //   AnswerName45:'',
      //   AnswerName46:'',
      //   AnswerName47:'',
      //   AnswerName48:'',
      //   AnswerName49:'',
      //   AnswerName50:'',
      //   AnswerName51:'',
      //   AnswerName51_1:'',
      //   AnswerName52:'',
      //   AnswerName52_1:'',
      //   AnswerName53:'',
      //   AnswerName53_1:'',
      //   AnswerName54:'',
      //   AnswerName54_1:'',
      //   AnswerName55:'',
      //   AnswerName56:'laifangzhe',
      //   AnswerName57:'',
      //   AnswerName58:'',
      //   AnswerName59:'',
      //   AnswerName60:'laifangzhe',
      //   AnswerName61:'',
      //   AnswerName62:'',
      //   AnswerName63:'',
      //   AnswerName64:'',
      //   AppointmentID:'xiaojinjin',
      // },
      from: {
        AnswerName1: 'laifangzhe',
        AnswerName2: '21616516546516',
        AnswerName3: '',
        AnswerName4: '',
        AnswerName5: '',
        AnswerName6: '',
        AnswerName7: '',
        AnswerName8: [],
        AnswerName9: '',
        AnswerName10: '',
        AnswerName11: [],
        AnswerName12: '',
        AnswerName13: '',
        AnswerName13_1: '',
        AnswerName14: '',
        AnswerName15: '',
        AnswerName16: '',
        AnswerName17: '',
        AnswerName18: '',
        AnswerName19: '',
        AnswerName20: '',
      },
      // rules: {
      //   AnswerName4: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName5: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName6: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName7: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName8: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName9: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName11: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName12: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName13: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName14: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName15: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName16: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName17: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName18: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName19: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      //   AnswerName20: [
      //     { required: true, message: '请完成危机评估', trigger: 'change' },
      //   ],
      // },
    }
  },
  methods: {
    handleHeaderCellClass({ row, column, rowIndex, columnIndex }) {
      this.orderArray.forEach((element) => {
        if (column.property === element.prop) {
          column.order = element.order
        }
      })
    },
    handleSortChange({ column, prop, order }) {
      //order值（ascending、descending、null）对应不同的排序方式
      this.drawer = true
    },
    handleEdit() {
      this.drawer = true
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          return false
        }
      })
    },
  },
  mounted() {
    // this.$Http_Post('ConsultSubscribe/FxResultAnswer', {
    //   AppointmentID: 'xiaojinjin',
    // }).then((res) => {
    //   if (res.Code == 200) {
    //     this.from.AnswerName1 = res.Data.AnswerName1
    //     this.from.AnswerName2 = res.Data.AnswerName2
    //     this.from.AnswerName3 = res.Data.AnswerName3
    //     this.from.AnswerName4 = res.Data.AnswerName4
    //     this.from.AnswerName5 = res.Data.AnswerName5
    //     this.from.AnswerName6 = res.Data.AnswerName6
    //     this.from.AnswerName7 = res.Data.AnswerName7
    //     this.from.AnswerName8 = res.Data.AnswerName8
    //     this.from.AnswerName9 = res.Data.AnswerName9
    //     this.from.AnswerName10 = res.Data.AnswerName10
    //     this.from.AnswerName11 = res.Data.AnswerName11
    //     this.from.AnswerName12 = res.Data.AnswerName12
    //     this.from.AnswerName13 = res.Data.AnswerName13
    //     this.from.AnswerName14 = res.Data.AnswerName14
    //     this.from.AnswerName15 = res.Data.AnswerName15
    //     this.from.AnswerName16 = res.Data.AnswerName16
    //     this.from.AnswerName17 = res.Data.AnswerName17
    //     this.from.AnswerName18 = res.Data.AnswerName18
    //     this.from.AnswerName19 = res.Data.AnswerName19
    //     this.from.AnswerName20 = res.Data.AnswerName20
    //     this.from.AnswerName21 = res.Data.AnswerName21
    //     this.from.AnswerName22 = res.Data.AnswerName22
    //     this.from.AnswerName23 = res.Data.AnswerName23
    //     this.from.AnswerName24 = res.Data.AnswerName24
    //     this.from.AnswerName25 = res.Data.AnswerName25
    //     this.from.AnswerName26 = res.Data.AnswerName26
    //     this.from.AnswerName27 = res.Data.AnswerName27
    //     this.from.AnswerName28 = res.Data.AnswerName28
    //     this.from.AnswerName29 = res.Data.AnswerName29
    //     this.from.AnswerName30 = res.Data.AnswerName30
    //     this.from.AnswerName31 = res.Data.AnswerName31
    //     this.from.AnswerName32 = res.Data.AnswerName32
    //     this.from.AnswerName33 = res.Data.AnswerName33
    //     this.from.AnswerName34 = res.Data.AnswerName34
    //     this.from.AnswerName35 = res.Data.AnswerName35
    //     this.from.AnswerName36 = res.Data.AnswerName36
    //     this.from.AnswerName37 = res.Data.AnswerName37
    //     this.from.AnswerName38 = res.Data.AnswerName38
    //     this.from.AnswerName39 = res.Data.AnswerName39
    //     this.from.AnswerName40 = res.Data.AnswerName40
    //     this.from.AnswerName41 = res.Data.AnswerName41
    //     this.from.AnswerName42 = res.Data.AnswerName42
    //     this.from.AnswerName43 = res.Data.AnswerName43
    //     this.from.AnswerName44 = res.Data.AnswerName44
    //     this.from.AnswerName44_1 = res.Data.AnswerName44_1
    //     this.from.AnswerName45 = res.Data.AnswerName45
    //     this.from.AnswerName46 = res.Data.AnswerName46
    //     this.from.AnswerName47 = res.Data.AnswerName47
    //     this.from.AnswerName48 = res.Data.AnswerName48
    //     this.from.AnswerName49 = res.Data.AnswerName49
    //     this.from.AnswerName50 = res.Data.AnswerName50
    //     this.from.AnswerName51 = res.Data.AnswerName51
    //     this.from.AnswerName51_1 = res.Data.AnswerName51_1
    //     this.from.AnswerName52 = res.Data.AnswerName52
    //     this.from.AnswerName52_1 = res.Data.AnswerName52_1
    //     this.from.AnswerName53 = res.Data.AnswerName53
    //     this.from.AnswerName53_1 = res.Data.AnswerName53_1
    //     this.from.AnswerName54 = res.Data.AnswerName54
    //     this.from.AnswerName54_1 = res.Data.AnswerName54_1
    //     this.from.AnswerName55 = res.Data.AnswerName55
    //     this.from.AnswerName56 = res.Data.AnswerName56
    //     this.from.AnswerName57 = res.Data.AnswerName57
    //     this.from.AnswerName58 = res.Data.AnswerName58
    //     this.from.AnswerName59 = res.Data.AnswerName59
    //     this.from.AnswerName60 = res.Data.AnswerName60
    //     this.from.AnswerName61 = res.Data.AnswerName61
    //     this.from.AnswerName62 = res.Data.AnswerName62
    //     this.from.AnswerName63 = res.Data.AnswerName63
    //     this.from.AnswerName64 = res.Data.AnswerName64
    //   }
    // })
  },
}
</script>
<style>
.Setdepartment .Setdepartment_top {
  padding-top: 20px;
  font-size: 20px;
  border: 1px solid #e3e3e3;
  padding-bottom: 20px;
  margin-top: -1px;
  background-color: #fff;
}
.Setdepartment .Setdepartment_top form {
  margin-left: 20px;
}
.Setdepartment button {
  height: 38px;
}
.Setdepartment .el-form-item {
  margin-bottom: 0px;
}
.Setdepartment .Thelist {
  background-color: #fff;
  margin-top: 18px;
}
.Setdepartment .Thelist button {
  height: 36px;
  line-height: 10px;
}
.Setdepartment .Thelist_left {
  width: 20%;
  border: 1px solid rgba(225, 226, 227, 1);
  margin-top: 15px;
  overflow-x: scroll;
  float: left;
}
.Setdepartment .Thelist_right {
  width: 100%;
  border: 1px solid rgba(225, 226, 227, 1);
  float: right;
  margin-top: 15px;
}
.Thelist_left h2 {
  padding: 18px;
  font-size: 18px;
}
.Setdepartment .Thelist_right h2 {
  padding: 18px;
  font-size: 18px;
}
.cldrawer h2 {
  padding: 18px;
  font-size: 18px;
}
.Setdepartment .el_form {
  width: 80%;
  margin-left: 20px;
}
.Setdepartment .el-form-item {
  margin-top: 20px;
}
.Setdepartment .cldrawer_btn {
  margin-left: 30%;
  margin-top: 40px;
}
.Setdepartment .tit span {
  width: 3px;
  height: 20px;
  background-color: rgba(0, 136, 255, 1);
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 0px;
}
.Setdepartment .tit p {
  position: absolute;
  left: 10px;
  top: -9px;
}
.Setdepartment .tit {
  position: relative;
  margin-top: 16px;
  height: 30px;
  margin-left: 20px;
}
.Setdepartment .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}
.Setdepartment .el-textarea {
  width: 70% !important;
}
.Setdepartment .el-radio {
  line-height: 30px;
}
.Setdepartment .el-form-item {
  margin-top: 10px;
}
.Setdepartment .el-textarea .el-input__count {
  color: #909399;
  background: #fff;
  position: absolute;
  font-size: 12px;
  bottom: 2px;
  right: 10px;
  height: 20px;
  line-height: 20px;
}
</style>
